import React, { useState } from 'react';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TestimonialsAndFaq() {
  const faqs = [{
    q: '¿Es para mí si no pienso dar clases particulares?',
    a: 'Sí. El 100% de las maestras con cargo que usan Aula de Éxitos reportan que dejaron de trabajar los domingos. El ahorro de tiempo es inmediato aunque nunca des una sola clase particular.'
  }, {
    q: '¿Es para mí si quiero emprender pero nunca lo hice?',
    a: 'Sí. El MegaPack incluye la guía completa de monetización paso a paso. No necesitás saber de negocios. Necesitás seguir el sistema.'
  }, {
    q: '¿Está realmente alineado al EBI? ¿O es material genérico con otra etiqueta?',
    a: 'Cada tomo fue desarrollado específicamente para el Programa EBI de ANEP Uruguay 2026. Con las competencias · los tramos · las metas y las progresiones del programa oficial. No es material argentino ni español adaptado. Es material uruguayo · para docentes uruguayos.'
  }, {
    q: '¿Cómo recibo el material después de pagar?',
    a: 'Inmediatamente después de confirmar el pago por Mercado Pago · recibís un correo electrónico con el link de descarga de todos los PDFs. Sin esperas. Sin envíos. Sin trámites.'
  }, {
    q: '¿Es editable?',
    a: 'Los PDFs están listos para usar directamente. Están diseñados para imprimir y aplicar sin necesidad de editar nada. Eso es justamente lo que te ahorra tiempo.'
  }, {
    q: '¿Puedo comprar un tramo ahora y otro más adelante?',
    a: 'Sí. Podés comprar por tramos cuando quieras. Pero el precio de lanzamiento del MegaPack es solo para los primeros 200 compradores. Cuando esos cupos se agoten · el precio vuelve a $7.960 UYU.'
  }, {
    q: '¿Sirve para una maestra con poca experiencia?',
    a: 'Especialmente para ella. Tener todo el año planificado con actividades listas y rúbricas claras le da a una docente nueva la seguridad y la estructura que le llevaría años desarrollar por su cuenta.'
  }, {
    q: '¿Qué pasa si compro y no es lo que esperaba?',
    a: 'Garantía de 7 días sin preguntas. Sin formularios. Sin justificaciones. Te devolvemos el dinero completo. El riesgo es nuestro · no tuyo.'
  }];
  return <>
      {/* SECCIÓN 8: TESTIMONIOS */}
      <section className="py-16 px-4 bg-brand-lightBlue" data-id="element-226">
        <div className="max-w-5xl mx-auto" data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep text-center mb-12" data-id="element-228">
            Esto dicen sobre Aula de Éxitos:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-229">
            {[{
            quote: 'Compré el Megapack un domingo. El lunes tenía todo el año organizado. Las rúbricas EBI son un lujo: evalúo en minutos y sin dudas.',
            author: 'Ana G.',
            loc: 'Montevideo · 5° y 6° año',
            initials: 'AG'
          }, {
            quote: 'Empecé con el Tramo 1. A los 3 días compré el Megapack completo. Trabajo en una escuela rural con múltiples grados y por fin tengo todo alineado al EBI.',
            author: 'Marcela F.',
            loc: 'Rivera · Inicial y 1°',
            initials: 'MF'
          }, {
            quote: 'Está organizado por tramo y alineado al EBI de ANEP. Es como tener un colega experto que ya hizo todo el trabajo por mí.',
            author: 'Roberto B.',
            loc: 'Salto · 3° y 4° año',
            initials: 'RB'
          }, {
            quote: 'Mis alumnos de 5° por fin se enganchan con todas las áreas. El contenido los conecta con Uruguay real. Ya no peleo con el teléfono en clase.',
            author: 'Carolina P.',
            loc: 'Canelones · 5° año',
            initials: 'CP'
          }, {
            quote: 'Compré el Tramo 4 para mis clases particulares. En el primer mes recuperé la inversión con solo 3 alumnos. Ahora tengo 8 y estoy pensando en abrir mi propio espacio.',
            author: 'Laura M.',
            loc: 'Montevideo · Clases particulares',
            initials: 'LM'
          }, {
            quote: 'Estaba sin cargo esperando concurso. Con el Megapack armé mi consultorio en casa. Hoy tengo 10 alumnos regulares y gano más que con el cargo público.',
            author: 'Fernanda R.',
            loc: 'Ciudad de la Costa · Emprendedora',
            initials: 'FR'
          }].map((test, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm" data-id="element-230">
                <div className="flex text-yellow-400 mb-4" data-id="element-231">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-232" />)}
                </div>
                <p className="text-brand-text font-medium mb-6 text-lg" data-id="element-233">
                  "{test.quote}"
                </p>
                <div className="flex items-center gap-4" data-id="element-234">
                  <div className="w-12 h-12 bg-brand-blue text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-235">
                    {test.initials}
                  </div>
                  <div data-id="element-236">
                    <div className="font-bold text-brand-deep" data-id="element-237">
                      {test.author}
                    </div>
                    <div className="text-sm text-brand-gray" data-id="element-238">{test.loc}</div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 11: GARANTÍA */}
      <section className="py-16 px-4 bg-brand-greenSoft text-center" data-id="element-239">
        <div className="max-w-2xl mx-auto" data-id="element-240">
          <ShieldCheck className="w-20 h-20 text-brand-green mx-auto mb-6" data-id="element-241" />
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep mb-6" data-id="element-242">
            GARANTÍA TOTAL DE 7 DÍAS
          </h2>
          <p className="text-xl text-brand-text font-medium mb-4 leading-relaxed" data-id="element-243">
            Usalo en el aula. Usalo en tus clases particulares. Probalo con tus
            alumnos.Si en 7 días no es exactamente lo que esperabas, te
            devolvemos el dinero completo. Sin preguntas. Sin formularios. Sin
            vueltas.
          </p>
        </div>
      </section>

      {/* SECCIÓN 10: FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-244">
        <div className="max-w-3xl mx-auto" data-id="element-245">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep text-center mb-10" data-id="element-246">
            ❓ Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-247">
            {faqs.map((faq, i) => <FaqItem key={i} question={faq.q} answer={faq.a} data-id="element-248" />)}
          </div>
        </div>
      </section>
    </>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white" data-id="element-249">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left hover:bg-brand-lightBlue/40 flex justify-between items-center gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue" data-id="element-250">
        <span className="font-bold text-brand-deep text-lg" data-id="element-251">{question}</span>
        <ChevronDown className={`w-5 h-5 text-brand-gray transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-252" />
      </button>
      <AnimatePresence data-id="element-253">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-254">
            <div className="px-6 pb-4 pt-2 text-brand-text font-medium" data-id="element-255">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}